import script from "./CollectionsNavAddButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionsNavAddButton.vue?vue&type=script&setup=true&lang=js"

import "./CollectionsNavAddButton.vue?vue&type=style&index=0&id=360e071b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-360e071b"]])

export default __exports__